import { render, staticRenderFns } from "./SimpleSpinner.vue?vue&type=template&id=15e84433&scoped=true&"
import script from "./SimpleSpinner.vue?vue&type=script&lang=js&"
export * from "./SimpleSpinner.vue?vue&type=script&lang=js&"
import style0 from "./SimpleSpinner.vue?vue&type=style&index=0&id=15e84433&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15e84433",
  null
  
)

export default component.exports